import { composeIO } from 'react-compose-io'
import { tabelaMovimentoContabilIO } from './TabelaMovimentoContabil.IO'
import { TabelaMovimentoContabilView } from './TabelaMovimentoContabil.View'

export const TabelaMovimentoContabil = composeIO(TabelaMovimentoContabilView, tabelaMovimentoContabilIO)
